import { render, staticRenderFns } from "./QaAssetsGallery.vue?vue&type=template&id=3313b45d&scoped=true&"
import script from "./QaAssetsGallery.vue?vue&type=script&lang=ts&"
export * from "./QaAssetsGallery.vue?vue&type=script&lang=ts&"
import style0 from "./QaAssetsGallery.vue?vue&type=style&index=0&id=3313b45d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3313b45d",
  null
  
)

export default component.exports